export class Helper {

  public static deserialize(data: string): any {
    return JSON.parse(data, Helper.reviveDateTime);
  }

  public static reviveDateTime(key: any, value: any): any {
    if (typeof value === 'string') {
      let dateValue: RegExpExecArray;
      // Valida data no formato "yyyy-mm-yyThh:mm:ss.fff"
      if (value.length === 19) {
        dateValue = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.exec(value);
      } else if (value.length === 23) { // Valida data no formato "yyyy-mm-yyThh:mm:ss"
        dateValue = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{3}$/.exec(value);
      }

      if (dateValue) {
        return new Date(dateValue[0]);
      }
    }
    return value;
  }

  // Metodo utilizado para formatação das faixas e critério
  public static getRangeValueFormated(name?: string, minValue?: number, maxValue?: number, precision?: number, abbreviation?: string, amplitudeTo: string = 'a') {
    return (name ? (name + ': ') : '') + minValue + ' ' + amplitudeTo + ' ' + maxValue + (precision ? ' | ' + precision : '') + (abbreviation ? ' (' + abbreviation + ')' : '');
  }

  // Método utilizado para calcular o total de páginas nas listagens
  public static getTotalPages(pageSize: number, overallCount: number) {
    return pageSize <= 0 || overallCount <= 0 ? 1 : (Math.ceil(overallCount / (pageSize)));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helpers/helper.ts